import axios from "axios";
import { BaseUrl } from "../config";
import { getSession } from "./authActions";
import { toast } from "react-toastify";

export const fetchIntervals = (selectedId) => {
  return async (dispatch) => {
    const { token } = getSession();
    dispatch({ type: "FETCH_INTERVALS_REQUEST" });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.get(
        `${BaseUrl}serviceCal/${selectedId}`,
        config
      );

      dispatch({ type: "FETCH_INTERVALS_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({
        type: "FETCH_INTERVALS_FAILURE",
        payload: error.response.data,
      });
    }
  };
};

export const addInterval = (checkedValues) => {
  return async (dispatch) => {
    dispatch({ type: "ADD_INTERVAL_REQUEST" });

    try {
      const { token } = getSession();

      // Determine the URL and method based on the presence of svc_cal_id
      const url = `${BaseUrl}serviceCal${
        checkedValues.svc_cal_id ? "/" + checkedValues.svc_cal_id : ""
      }`;
      const method = checkedValues.svc_cal_id ? "put" : "post";

      // Make the request using the determined method
      const response = await axios({
        method: method,
        url: url,
        data: checkedValues,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({
        type: "ADD_INTERVAL_SUCCESS",
        payload: response.data,
      });
      toast.success(response.data.usr.message);
    } catch (error) {
      dispatch({
        type: "ADD_INTERVAL_FAILURE",
        payload: error.response.data,
      });
    }
  };
};

export const resetCalender = () => async (dispatch) => {
  try {
    dispatch({ type: "Reset_interval" });
  } catch (error) {
    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};
